import { message, Modal } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";
import CopyToClipboard from "react-copy-to-clipboard";
import { CopyOutlined } from "@ant-design/icons";

export const PinActivation = ({ open, toClose, onModalClose, accountId, errorMessage }) => {
  const navigate = useNavigate();

  const handleCancelModal = () => {
    toClose(true);
  };

  return (
    <Modal
      open={open}
      footer={false}
      onCancel={handleCancelModal}
      className="underConstructionModal"
    >
      <div className="flex flex-col justify-center mt-10 items-center">
        {errorMessage && (
          <p className="text-red-500 bg-red-50 p-2 text-center mb-2 px-4">
            {errorMessage}
          </p>
        )}
        <h2 className="font-bold text-center my-4 text-3xl">
          Set your <span className="uppercase font-bold text-green-600">4-Digit Transaction PIN</span> to secure wallet transfers.
        </h2>
        <p className="text-gray-600 text-sm text-center mb-4 px-2">
          Your SMS Account Verification is complete! Create a 4-digit Transaction PIN to protect your wallet transactions and withdrawals.
        </p>
        <span className="p-4 bg-green-50 uppercase tracking-wider text-green-600 font-gilroyBold rounded-xl">
          Your Account ID:{"  "}
          <CopyToClipboard
            text={accountId}
            onCopy={() => message.success("Account ID copied to clipboard!")}
          >
            <span
              style={{
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center",
              }}
            >
              {accountId}
              <CopyOutlined style={{ marginLeft: "20px", fontSize: "16px" }} />
            </span>
          </CopyToClipboard>
        </span>
        <button
          onClick={() => navigate("/profile/trans-pin")}
          className="rounded-button font-gilroyBold my-6 focus:outline-none bg-black hover:bg-gray-800 text-white px-8 py-3 rounded-2xl shadow-md"
        >
          Set Transaction PIN
        </button>
      </div>
    </Modal>
  );
};
